import { render } from "./InputBarPillDev.vue?vue&type=template&id=c447a558"
import script from "./InputBarPillDev.vue?vue&type=script&lang=js"
export * from "./InputBarPillDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__